import React, {useEffect, useState} from 'react';
import ReactDOM from "react-dom/client";
import queryString from 'query-string';
import useFetchData from './fetcher';
import FilterSearch from './filter-search';
import FilterPRYears from './filter-pr-years';
import Pagination from './pagination';
import LoadingAnimation from './loading-animation';
import NoResults from './no-results';

import './scss/press-release-index.scss';


const PressReleaseIndexApp = (props) => {
  const langcode = (drupalSettings.path.currentLanguage == 'en') ? '/' : '/' + drupalSettings.path.currentLanguage + '/';
  const fetchUrl = langcode + 'rest-api/cp-pr-index-data';
  const [fetch, setFetch] = useState(fetchUrl);
  const [filters, setFilters] = useState({search: '', year: ''});
  const [isReady, setIsReady] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const appDiv = document.getElementsByClassName(props.appDiv)[0];

  useEffect(() => {
    // get from filed 'options' in the parent block.
    const options = appDiv.closest('.block-plugin').nextElementSibling.dataset.options;
    const objOptions = {};

    if (options) {
    // String options into object.
      options.split(',').forEach(pair => {
          const [key, value] = pair.split(':');
          objOptions[key.trim()] = value.trim(); 
      });
    }

    // Set initial filters from block options or url hash.
    const parsed = (Object.keys(objOptions).length > 0) ? objOptions : queryString.parse(location.hash);

    setFilters(parsed);

    setIsReady(true);
  }, []);

  // Fetch data from the rest resource.
  useEffect(() => {
    if (isReady) {
      useFetchData(fetch, setData, setLoading);
    }
  }, [fetch]);

  // Build the fetch url based on search and filters.
  useEffect(() => {
    setLoading(true);
    if (isReady) {
      // Update browser hash with the current filters and set new fetch url.
      location.hash = queryString.stringify(filters);
      setFetch(`${fetchUrl}?${queryString.stringify(filters)}`);
    }
  }, [filters]);

  const scrollTop = () => {
    // Scroll to top of the app. 
    window.scrollTo({
      top: appDiv.offsetTop + 40,
      behavior: "smooth"
    });
  }

  return (
    <>
      {loading && <LoadingAnimation />}

      {/* List Blog posts. */}
      <div className='list' id="press-release-list-wrapper">
        <div className="press-release-list">
          {(!loading && !filters.limit) && (
            <div className='filters'>
              <FilterPRYears dataFilters={data.filters} setFilters={setFilters} filters={filters} selected={filters.year} isReady={isReady} />

              <FilterSearch filters={filters} isReady={isReady} loading={loading} list={data.press_releases} pagination={data.pagination} setFilters={setFilters} searchFor={Drupal.t('Press Releases')} />
            </div>
          )}

        {(!loading && data.press_releases && data.filters) && (
          <div className='press-release-node-list tiles-container'>
            {(data.press_releases.length > 0) ? data.press_releases.map((item, i) => (
              <a key={i} className="tile-link" href={item.node_alias}>
                <div className="tile">
                  <img src={item.image} alt={item.title} className='pr_thumb_image' loading='lazy' />
                  <div className="press-release-info padding">
                    <p className="grey">{item.pr_date}</p>
                    <h3 className='mb40'>{item.title}</h3>
                    <p className="product-more-link">{Drupal.t('Read more')}</p>
                  </div>
                </div>
              </a>
            )) : (
              <NoResults setFilters={setFilters} />
            )}
          </div>
        )}

        {/* Pagination */}
        {(!loading && !filters.limit && data.pagination && data.pagination.pages > 1) && (
          <Pagination pagination={data.pagination} setFilters={setFilters} filters={filters} isReady={isReady} scrollTop={scrollTop} />
        )}
      </div>
      </div>
    </>
  );
};

const appDiv ='cp-pr-index-app';
const appRoot = document.querySelectorAll(`.${appDiv}`);
appRoot.forEach((element) => {
  const root = ReactDOM.createRoot(element);
  root.render(
    <React.StrictMode>
      <PressReleaseIndexApp appDiv={appDiv} />
    </React.StrictMode>
  );
});
